// Xiangqi engine
export const RED='r', BLACK='b';
export const initialBoard=()=>[
['br','bn','bb','ba','bk','ba','bb','bn','br'],
[null,null,null,null,null,null,null,null,null],
[null,'bc',null,null,null,null,null,'bc',null],
['bp',null,'bp',null,'bp',null,'bp',null,'bp'],
[null,null,null,null,null,null,null,null,null],
[null,null,null,null,null,null,null,null,null],
['rp',null,'rp',null,'rp',null,'rp',null,'rp'],
[null,'rc',null,null,null,null,null,'rc',null],
[null,null,null,null,null,null,null,null,null],
['rr','rn','rb','ra','rk','ra','rb','rn','rr']
];
export const side=p=>p&&p[0];
export const type=p=>p&&p[1];
const inside=(r,c)=>r>=0&&r<10&&c>=0&&c<9;
const palace=(s,r,c)=>c>=3&&c<=5&&(s===RED?r>=7&&r<=9:r>=0&&r<=2);
const clone=b=>b.map(x=>x.slice());
export function pseudoMoves(b,r,c){
 const p=b[r][c]; if(!p)return[]; const s=side(p),t=type(p), out=[];
 const add=(rr,cc)=>{if(inside(rr,cc)&&(!b[rr][cc]||side(b[rr][cc])!==s))out.push([rr,cc]);};
 if(t==='r'||t==='c'){
  for(const [dr,dc] of [[1,0],[-1,0],[0,1],[0,-1]]){
   let rr=r+dr,cc=c+dc,screen=false;
   while(inside(rr,cc)){
    if(t==='r'){
     if(!b[rr][cc])out.push([rr,cc]); else {if(side(b[rr][cc])!==s)out.push([rr,cc]);break;}
    } else {
     if(!screen){if(!b[rr][cc])out.push([rr,cc]);else screen=true;}
     else if(b[rr][cc]){if(side(b[rr][cc])!==s)out.push([rr,cc]);break;}
    }
    rr+=dr;cc+=dc;
   }
  }
 }
 if(t==='n'){
  for(const [dr,dc,lr,lc] of [[-2,-1,-1,0],[-2,1,-1,0],[2,-1,1,0],[2,1,1,0],[-1,-2,0,-1],[1,-2,0,-1],[-1,2,0,1],[1,2,0,1]])
   if(inside(r+lr,c+lc)&&!b[r+lr][c+lc]) add(r+dr,c+dc);
 }
 if(t==='b'){
  for(const [dr,dc] of [[-2,-2],[-2,2],[2,-2],[2,2]]){
   const rr=r+dr,cc=c+dc;
   if(inside(rr,cc)&&!b[r+dr/2][c+dc/2]&&(s===RED?rr>=5:rr<=4))add(rr,cc);
  }
 }
 if(t==='a') for(const [dr,dc] of [[-1,-1],[-1,1],[1,-1],[1,1]]){const rr=r+dr,cc=c+dc;if(palace(s,rr,cc))add(rr,cc);}
 if(t==='k'){
  for(const [dr,dc] of [[-1,0],[1,0],[0,-1],[0,1]]){const rr=r+dr,cc=c+dc;if(palace(s,rr,cc))add(rr,cc);}
  let rr=r+(s===RED?-1:1);
  while(inside(rr,c)){if(b[rr][c]){if(type(b[rr][c])==='k'&&side(b[rr][c])!==s)out.push([rr,c]);break;} rr+=(s===RED?-1:1);}
 }
 if(t==='p'){
  add(r+(s===RED?-1:1),c);
  if(s===RED?r<=4:r>=5){add(r,c-1);add(r,c+1);}
 }
 return out;
}
export function isInCheck(b,s){
 let kr=-1,kc=-1;
 for(let r=0;r<10;r++)for(let c=0;c<9;c++)if(b[r][c]===s+'k'){kr=r;kc=c;}
 if(kr<0)return true;
 const e=s===RED?BLACK:RED;
 for(let r=0;r<10;r++)for(let c=0;c<9;c++)if(side(b[r][c])===e&&pseudoMoves(b,r,c).some(([rr,cc])=>rr===kr&&cc===kc))return true;
 return false;
}
export function legalMoves(b,s){
 const out=[];
 for(let r=0;r<10;r++)for(let c=0;c<9;c++)if(side(b[r][c])===s){
  for(const [rr,cc] of pseudoMoves(b,r,c)){
   const n=clone(b); n[rr][cc]=n[r][c];n[r][c]=null;
   if(!isInCheck(n,s))out.push({from:[r,c],to:[rr,cc],capture:b[rr][cc]});
  }
 }
 return out;
}
export function applyMove(b,m){const n=clone(b);n[m.to[0]][m.to[1]]=n[m.from[0]][m.from[1]];n[m.from[0]][m.from[1]]=null;return n;}
const V={k:100000,r:900,c:450,n:400,b:200,a:200,p:100};
export function evaluate(b){
 let v=0;
 for(let r=0;r<10;r++)for(let c=0;c<9;c++){const p=b[r][c];if(p){let x=V[type(p)];if(type(p)==='p'&&(side(p)===RED?r<=4:r>=5))x+=40;v+=(side(p)===BLACK?x:-x);}}
 return v;
}
export function gameState(b,s){
 const ms=legalMoves(b,s);
 if(ms.length)return {over:false,check:isInCheck(b,s)};
 return {over:true,winner:s===RED?BLACK:RED,check:isInCheck(b,s)};
}
